export default __webpack_public_path__ + "static/media/tecnologiasmarthome.83636d05.svg";